import { queryOptions } from '@tanstack/react-query';
import type { ListCategoriesQuery } from '@klopotun/contracts';
import { categoryQueryRoot } from '../../../../shared/api/index.js';
import { getCategories } from '../requests/get-categories.js';

const CATEGORIES_ON_OFFER: ListCategoriesQuery = { includeArchived: false };

export const categoryQueries = {
  ...categoryQueryRoot,
  list: (query: ListCategoriesQuery = CATEGORIES_ON_OFFER) =>
    queryOptions({
      queryKey: [...categoryQueryRoot.lists(), query] as const,
      queryFn: ({ signal }) => getCategories(query, signal),
    }),
};
